import type { ConfigId } from "@/constants/ConfigData";
import {
  ConfluenceIcon,
  GoogleDriveIcon,
  NotionIcon,
  SalesforceIcon,
} from "@/pages/cbb-builder/components/AiBotAssets";

type ConnectAppItem = {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  key: ConfigId;
};

type ConnectAppGroup = {
  title: string;
  apps: ConnectAppItem[];
};

export const connectAppGroups: ConnectAppGroup[] = [
  {
    title: "Knowledge Bases",
    apps: [
      {
        title: "Notion",
        subtitle: "Train your bot using Notion pages and documents.",
        icon: <NotionIcon />,
        key: "notion",
      },
      {
        title: "Confluence",
        subtitle: "Train your bot using Confluence pages.",
        icon: <ConfluenceIcon />,
        key: "confluence",
      },
    ],
  },
  {
    title: "CRM",
    apps: [
      {
        title: "Salesforce",
        subtitle: "Import knowledge articles from Salesforce.",
        icon: <SalesforceIcon />,
        key: "salesforce",
      },
    ],
  },
  {
    title: "Cloud Storage",
    apps: [
      {
        title: "Google Drive",
        subtitle: "Train your bot using files from Google Drive.",
        icon: <GoogleDriveIcon />,
        key: "googlepicker",
      },
    ],
  },
];

export const ConnectIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M13.15 4.44H11.39V1.75C11.39 1.55 11.31 1.36 11.17 1.22C11.03 1.08 10.84 1 10.64 1C10.44 1 10.25 1.08 10.11 1.22C9.97 1.36 9.89 1.55 9.89 1.75V4.44H6.11V1.75C6.11 1.55 6.03 1.36 5.89 1.22C5.75 1.08 5.56 1 5.36 1C5.16 1 4.97 1.08 4.83 1.22C4.69 1.36 4.61 1.55 4.61 1.75V4.44H2.85C2.65 4.44 2.46 4.51 2.32 4.65C2.18 4.8 2.1 4.99 2.1 5.19C2.1 5.38 2.18 5.57 2.32 5.72C2.46 5.86 2.65 5.94 2.85 5.94H3.42V8.04C3.42 10.31 5.08 12.19 7.25 12.55V15.75C7.25 15.95 7.33 16.14 7.47 16.28C7.61 16.42 7.8 16.5 8 16.5C8.2 16.5 8.39 16.42 8.53 16.28C8.67 16.14 8.75 15.95 8.75 15.75V12.55C10.92 12.19 12.58 10.31 12.58 8.04V5.94H13.15C13.35 5.94 13.54 5.86 13.68 5.72C13.82 5.57 13.9 5.38 13.9 5.19C13.9 4.99 13.82 4.8 13.68 4.65C13.54 4.51 13.35 4.44 13.15 4.44ZM11.08 8.04C11.08 9.74 9.7 11.12 8 11.12C6.3 11.12 4.92 9.74 4.92 8.04V5.94H11.08V8.04Z"
        fill="currentColor"
      />
    </svg>
  );
};
